/**
 * Fractional indexing over base-62 digits: keyBetween(a, b) returns a key that
 * sorts strictly between a and b (null = open end). Keeps reorders to one write.
 */
const DIGITS = '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz';
const BASE = DIGITS.length;

function digit(s: string, i: number, fallback: number): number {
  const c = s[i];
  return c === undefined ? fallback : DIGITS.indexOf(c);
}

export function keyBetween(a: string | null, b: string | null): string {
  const lo = a ?? '';
  const hi = b;
  if (hi !== null && lo >= hi) throw new Error(`keyBetween: ${lo} >= ${hi}`);
  if (hi !== null && /^0*$/.test(hi))
    throw new Error('keyBetween: nothing sorts below an all-zero key');
  let result = '';
  for (let i = 0; ; i++) {
    const dl = digit(lo, i, 0);
    const dh = hi === null ? BASE : digit(hi, i, 0);
    if (dl === dh) {
      result += DIGITS[dl];
      continue;
    }
    if (dh - dl > 1) return result + DIGITS[Math.floor((dl + dh) / 2)];
    // Adjacent digits: take the low digit and find room further right of `lo`.
    result += DIGITS[dl];
    for (let j = i + 1; ; j++) {
      const d = digit(lo, j, 0);
      if (d < BASE - 1) return result + DIGITS[Math.ceil((d + BASE) / 2)];
      result += DIGITS[d];
    }
  }
}
